import { render } from "./EventsSimpleSearcher.vue?vue&type=template&id=b240b586&lang=pug"
import script from "./EventsSimpleSearcher.vue?vue&type=script&lang=js"
export * from "./EventsSimpleSearcher.vue?vue&type=script&lang=js"

import exportComponent from "/builds/mfar.technology/events/events-platform/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__